import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const DEVICE_TZ = dayjs.tz.guess();
export const SERVER_TZ = "UTC";

const HAS_TZ = (s: string) => /Z$|[+-]\d\d:?\d\d$/.test(s);

export const fromServerToLocal = (iso?: string) => {
  if (!iso) return null;
  if (HAS_TZ(iso)) {
    return dayjs(iso).tz(DEVICE_TZ);
  }
  return dayjs.tz(iso, SERVER_TZ).tz(DEVICE_TZ);
};

export const toServerUtcIso = (d?: dayjs.Dayjs | null) =>
  d ? d.tz(DEVICE_TZ).utc().format("YYYY-MM-DDTHH:mm:ss[Z]") : "";

export const toServerUtcDate = (d?: dayjs.Dayjs | null) =>
  d ? d.format("YYYY-MM-DD") : null;

export const normalizeIsoUtc = (iso?: string) => {
  if (!iso) return "";
  const d = HAS_TZ(iso) ? dayjs(iso) : dayjs.tz(iso, SERVER_TZ);
  return d.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
};
